import Vue from "vue";
import VueI18n from "VueI18n";
import Chinese from "./chinese";
import English from "./english";
Vue.use(VueI18n);
let ChineseData=Chinese;
let EnglishData=English
function lange() {
  if (window.localStorage.lange == undefined) {
    if (window.navigator.languages && window.navigator.languages.length > 0) {
      return window.navigator.languages[0].split("-")[0];
    } else {
      return window.navigator.language.split("-")[0];
    }
  } else {
    return window.localStorage.lange;
  }
}
let reg = /^app./g;
let hostname = window.location.hostname;
if (!reg.test(hostname) || hostname == "app.ecs.net") {
  hostname = 'app.lchtrip.com';
}
if(hostname=='app.wmytrip.cn'){
   ChineseData=JSON.parse(JSON.stringify(Chinese).replace(/力程商旅/g,'我们游商旅').replace(/400-088-8020/g,'400-663-0388'))
   EnglishData=JSON.parse(JSON.stringify(English).replace(/Licheng/g,'womenyou').replace(/www.lichengtrip.net/g,'app.wmytrip.cn').replace(/400-088-8020/g,'400-663-0388'))
}
export default new VueI18n({
  locale: lange() == 'zh' ? 'cn' : lange(),
  fallbackLocale: "en",
  messages: {
    cn: ChineseData,
    en: EnglishData
  }
});



// WEBPACK FOOTER //
// ./src/language/index.js